/**
 * @file PaymentPage.tsx
 * @module app/modules/payment-page/PaymentPage
 * @description Implements the PaymentPage interface in the payment-page workflow.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes } from 'react-router-dom';
import { PaymentSuccess } from './components/payment-success';
import { PaymentLayout } from './PaymentLayout';
const PaymentPage = () => (
  <Routes>
    <Route element={<PaymentLayout />}>
      <Route
        path="success"
        element={<PaymentSuccess />}
      />
      <Route
        index
        element={<PaymentSuccess />}
      />
    </Route>
  </Routes>
);
export { PaymentPage };
